import type { Event, IncompleteEvent } from '../../../../types/DirectusSchema';
import { notEmpty } from '../../lib/notEmpty.ts';

export const parseTargetAudiences = (
  targetAudiences: IncompleteEvent['target_audiences'] | Event['target_audiences'],
) => {
  const parsedTargetAudiences = targetAudiences
    ?.map((targetAudience) => (typeof targetAudience === 'object' ? targetAudience : null))
    .filter(notEmpty);

  // Maps over each target audience and extracts the id and target_audiences_id if they are valid objects
  return parsedTargetAudiences?.map((targetAudience) => ({
    id: targetAudience.id,
    target_audiences_id:
      typeof targetAudience.target_audiences_id === 'object' ? targetAudience.target_audiences_id : null,
  }));
};
